import h, { FunctionComponent } from 'preact';
import Currency from '../common/Currency';
import DeliveryOptions from './DeliveryOptions';
import { DeliveryOption } from '../types';

const BasketTableFooter: FunctionComponent<BasketTableFooterProps> = ({ itemCount, subtotal, subtotalExcludingDelivery, tax, taxExcludingDelivery, total, deliveryOptions, deliveryOption, deliveryPrice }) => {
    return <tfoot class="basket__totals">
    <tr>
        <th scope="row" colSpan={5} class="text-right text-blue font-weight-normal">
            Subtotal
        </th>
        <td class="border-left border-right border-bottom font-weight-bold text-blue text-left">
            <span class="d-inline-block" id="js-basket-total"><Currency amount={subtotal} /></span>
        </td>
    </tr>
    <tr>
        <td colSpan={5}>
            <div>Delivery cost calculated at checkout</div>
        </td>
        <td class="border-left border-right border-bottom font-weight-bold text-blue text-left">
            -
        </td>
    </tr>
    <tr>
        <th scope="row" colSpan={5} class="text-right text-blue font-weight-normal">
            VAT
        </th>
        <td class="border-left border-right border-bottom font-weight-bold text-blue text-left">
            <span class="d-inline-block" id="js-basket-total"><Currency amount={taxExcludingDelivery} /></span>
        </td>
    </tr>
    <tr>
        <th scope="row" colSpan={5} class="text-right text-blue font-weight-normal">
            Total
        </th>
        <td class="border-left border-right border-bottom font-weight-bold text-blue text-left">
            <span class="d-inline-block" id="js-basket-total"><Currency amount={subtotalExcludingDelivery} /></span>
        </td>
    </tr>
    </tfoot>;
};

interface BasketTableFooterProps {
    itemCount: number;
    subtotal: string;
    subtotalExcludingDelivery: string;
    tax: string;
    taxExcludingDelivery: string;
    total: string;
    deliveryOptions: Array<DeliveryOption>;
    deliveryOption: number | null;
    deliveryPrice: string | null;
}

export default BasketTableFooter;
